import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfigurationService } from 'src/app/services/configuration.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule
  ],
  providers: [ConfigurationService]
})
export class LoginModule { }
